<template>
  <div class="customer-history">
    <!-- Date Filters -->
    <b-row class="mb-4 align-items-end">
      <b-col md="3" sm="5">
        <label class="small text-muted font-weight-bold">Từ ngày</label>
        <date-picker
          placeholder="Chọn ngày bắt đầu"
          class="form-control form-control-sm"
          :config="datePickerConfig"
          v-model="filters.fromDate"
        ></date-picker>
      </b-col>
      <b-col md="3" sm="5">
        <label class="small text-muted font-weight-bold">Đến ngày</label>
        <date-picker
          placeholder="Chọn ngày kết thúc"
          class="form-control form-control-sm"
          :config="datePickerConfig"
          v-model="filters.toDate"
        ></date-picker>
      </b-col>
      <b-col md="3" sm="2">
        <b-button
          variant="primary"
          size="sm"
          @click="onApplyFilter"
          class="font-weight-bolder"
        >
          <i class="fas fa-search mr-1"></i> Lọc
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          @click="onResetFilter"
          class="ml-2"
        >
          Làm mới
        </b-button>
      </b-col>
    </b-row>

    <warranty-list-table
      detail-mode="dispatch"
      :items="items"
      :fields="fields"
      :is-loading="isLoading"
      :total-items="totalItems"
      :number-of-page="totalPages"
      :current-page="Number(currentPage)"
      :limit="10"
      :pagination-link-params="{ id: customerId }"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import ApiService from '@/core/services/api.service';
import { mapWarrantyListItem } from '@/view/pages/warranty/utils/listHelpers';
import WarrantyListTable from '@/view/pages/warranty/components/WarrantyListTable.vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
import useCustomerHistory from '../composables/useCustomerHistory';

export default defineComponent({
  name: 'CustomerWarrantyHistoryTab',

  components: {
    WarrantyListTable,
    datePicker,
  },

  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
  },

  setup(props) {
    const filters = ref({
      fromDate: null,
      toDate: null,
    });

    const datePickerConfig = {
      format: 'DD/MM/YYYY',
      useCurrent: false,
      showClear: true,
      showClose: true,
      locale: 'vi',
    };

    // Tái dùng cấu trúc cột của trang danh sách bảo hành, bỏ cột thao tác (chỉ xem)
    const fields = [
      { key: 'id', label: 'ID', sortable: false, thStyle: { width: '10%' } },
      {
        key: 'imeiCode',
        label: 'Sản phẩm',
        sortable: false,
        thStyle: { width: '16%' },
      },
      {
        key: 'customerPhone',
        label: 'Khách hàng',
        sortable: false,
        thStyle: { width: '11%' },
      },
      {
        key: 'statusName',
        label: 'Trạng thái',
        sortable: false,
        thStyle: { width: '12%' },
      },
      {
        key: 'info',
        label: 'Thông tin',
        sortable: false,
        thStyle: { width: '21%' },
      },
      {
        key: 'note',
        label: 'Ghi chú',
        sortable: false,
        thStyle: { width: '19%' },
      },
      {
        key: 'storeName',
        label: 'Tại',
        sortable: false,
        thStyle: { width: '11%' },
      },
      {
        key: 'paymentStatus',
        label: 'Thanh toán',
        sortable: false,
        thStyle: { width: '12%' },
      },
    ];

    const loadWarranties = async (page) => {
      const params = {
        page,
        limit: 10,
        mode: 'dispatch',
        customerId: Number(props.customerId),
      };

      if (filters.value.fromDate) {
        params.startDate = moment(filters.value.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      if (filters.value.toDate) {
        params.endDate = moment(filters.value.toDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      const response = await ApiService.query('v1/warranties', { params });
      const data = response.data.data || {};
      return {
        items: (data.dataset || []).map((item) => mapWarrantyListItem(item)),
        totalRow: data.totalRow || 0,
        totalPage: data.totalPage || 0,
      };
    };

    const {
      items,
      totalItems,
      totalPages,
      currentPage,
      isLoading,
      fetchPage,
      onPageChange,
    } = useCustomerHistory(loadWarranties);

    const onApplyFilter = () => {
      fetchPage(1);
    };

    const onResetFilter = () => {
      filters.value.fromDate = null;
      filters.value.toDate = null;
      fetchPage(1);
    };

    onMounted(() => {
      if (props.customerId) {
        fetchPage(1);
      }
    });

    return {
      items,
      totalItems,
      totalPages,
      currentPage,
      isLoading,
      fields,
      onPageChange,
      filters,
      datePickerConfig,
      onApplyFilter,
      onResetFilter,
    };
  },
});
</script>

<style scoped>
.customer-history {
  padding: 1rem 0;
}
</style>
